import { Space, TableColumnsType, Tag } from "antd";

export interface RecordRow {
  name: string;
  color: string;
  base_requirements: any[];
  onClick: () => void;
}

export const TEMPLATES_TABLE_HEAD: TableColumnsType<RecordRow> = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    render: (_: any, record: RecordRow) => <Space>{record.name}</Space>,
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.name.localeCompare(b.name),
    sortDirections: ["ascend", "descend"],
  },
  {
    title: "Requisitos",
    dataIndex: "requirements",
    key: "requirements",
    render: (_: any, record: RecordRow) => (
      <Space>
        <Tag color={record.color}>{record.base_requirements.length}</Tag>
      </Space>
    ),
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.base_requirements.length - b.base_requirements.length,
    sortDirections: ["ascend", "descend"],
  },
  /*{
    title: <span className="mx-auto flex justify-center">Acciones</span>,
    dataIndex: 'detail',
    key: 'detail',
    render: (_: any, record: RecordRow) => (
      <Space className="flex justify-center items-center w-full">
        <Tooltip content="Ver detalles">
          <IconButton variant="text" onClick={record.onClick}>
            <EyeIcon className="h-4 w-4"/>
          </IconButton>
        </Tooltip>
      </Space>
    ),
  },*/
];
